import { useAuth } from "@/hooks/use-auth";
import { Navigate } from "react-router";
import { CheckEmail } from "@/features/account/components/verify-email/check-email";

function VerifyEmail() {
    const { user } = useAuth();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return <CheckEmail />;
}

export default VerifyEmail;
